'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'balloons';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = 'M201.3 339.3c11.6-10.4 27-25.4 42.4-43.6 31.3-37.1 60.2-85.4 60.2-135.7 0-79.5-64.5-144-144-144S16 80.5 16 160c0 50.2 29 98.6 60.2 135.7 15.4 18.3 30.8 33.3 42.4 43.6 8.2 7.4 16.6 14.1 25.3 20.7l32 0c8.7-6.6 17.1-13.3 25.3-20.7zM119.6 432l80.7 0-22.4-56-35.9 0-22.4 56zM224 448l-128 0 32-80S0 272 0 160C0 71.6 71.6 0 160 0S320 71.6 320 160c0 112-128 208-128 208l32 80zM152 96c-30.9 0-56 25.1-56 56l0 8-16 0 0-8c0-39.8 32.2-72 72-72l8 0 0 16-8 0zM294 335.3c3.5-4.2 7.1-8.6 10.6-13.2 8.5 13.4 17.9 26 27.6 37.5 15.4 18.3 30.8 33.3 42.4 43.6 8.2 7.4 16.6 14.1 25.3 20.7l32 0c8.7-6.6 17.1-13.3 25.3-20.7 11.6-10.4 27-25.4 42.4-43.6 31.3-37.1 60.2-85.4 60.2-135.7 0-79.5-64.5-144-144-144-21.1 0-41.1 4.5-59.1 12.7-1.7-5.1-3.7-10.1-5.8-15 19.8-8.8 41.8-13.7 64.9-13.7 88.4 0 160 71.6 160 160 0 112-128 208-128 208l32 80-128 0 32-80s-52.2-39.2-90-96.7zM398 440l-22.4 56 80.7 0-22.4-56-35.9 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;